import { DEFAULT_CLAN_NAME } from "../../models/config/balance.ts";
import { resolveWorldBalance } from "../../models/config/worldBalance.ts";
import { DEFAULT_TOTEM_ID, isTotemId, type TotemId } from "../../models/totem.ts";
import type { WorldState } from "../../models/worldState.ts";
import { normalizeClanName } from "../clan/normalizeClanName.ts";
import type { ReduceContext } from "../context.ts";
import { appendGeneratedTiles } from "../factory/generateWorldTiles.ts";
import { rejectCommand } from "../rejectCommand.ts";
import type { ReduceResult } from "../result.ts";

const DEFAULT_CLAN_NAME_BY_LOCALE: Record<string, string> = {
  en: DEFAULT_CLAN_NAME,
  it: "Il tuo clan",
};

export function reduceSelectTotem(
  state: WorldState,
  name: string,
  totemId: TotemId | undefined,
  context: ReduceContext = {},
): ReduceResult {
  const locale = context.locale ?? "en";
  const defaultName = DEFAULT_CLAN_NAME_BY_LOCALE[locale] ?? DEFAULT_CLAN_NAME;
  const clanName = normalizeClanName(name, defaultName);
  if (totemId !== undefined && !isTotemId(totemId)) {
    return rejectCommand(
      state,
      { type: "SelectTotem", name, totemId },
      "unknown-totem",
    );
  }
  const resolvedTotemId = totemId ?? DEFAULT_TOTEM_ID;

  const balance = resolveWorldBalance(context.balance);
  const withMap =
    Object.keys(state.tiles).length > 0
      ? state
      : appendGeneratedTiles(state, state.rng.seed, balance);

  return {
    state: {
      ...withMap,
      phase: "selectingStart",
      clan: {
        ...withMap.clan,
        clanName,
        totemId: resolvedTotemId,
      },
    },
    events: [{ type: "TotemSelected", clanName, totemId: resolvedTotemId }],
  };
}
